import React, { useEffect } from 'react'
import { get } from 'lodash'
import { useHistory }  from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import AdminCommonListLayout from './AdminCommonListLayout'
import { adminGalleriesList } from '../actions/admin_galleries'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  gallery_image: {
      maxWidth: '120px',
  }
}))

export const AdminGalleries = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const classes = useStyles()
  const is_loading = useSelector(() => adminGalleriesList.isLoading())

  const columns = [
    {
      field: 'gallery_name',
      title: 'Gallery Name',
    },
    {
      field: 'album_name',
      title: 'Album',
    },
    {
      field: 'gallery_event_name',
      title: 'Gallery Event',
    },
    {
      field: 'photographer_name',
      title: 'Photographer',
    },
    {
      field: 'num_photographs',
      title: 'Num Photos',
    },
    {
      field: 'indexed_for_facial_recognition',
      title: 'Face Recognition',
      render: (item) => item.indexed_for_facial_recognition ? 'Yes' : 'No'
    },
    {
      field: 'created_at',
      title: 'Created At',
      render: (item) => {
        const date = new Date(item.created_at)
        return date.toLocaleString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        })
      }
    },
  ]

  useEffect(() => {
    async function fetchStaticObjects() {
      dispatch(adminGalleriesList.fetchListIfNeeded())
    }
    fetchStaticObjects()
  }, [])

  const onAddGallery = () => {
    history.push('/admin/gallery/')
  }

  const onEditGallery = (gallery_id) => {
    history.push(`/admin/gallery/${ gallery_id }`)
  }

    return (
      <AdminCommonListLayout
        active_key='galleries'
        breadcrumbs={[
          { name: 'admin_home' },
          {
            name: 'galleries',
            label: 'Galleries',
            url: '/admin/galleries',
          },
        ]}
        columns={ columns }
        is_loading={ is_loading }
        item_list={ adminGalleriesList }
      />
    )
}
